import React from 'react';

import { IconBasePropsWithColor } from './IconBase';

const Venmo: React.FC<IconBasePropsWithColor> = ({
  height = 24,
  width = 24,
  color = '#3396CD',
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M21.1628 0H2.83721C1.27026 0 0 1.27026 0 2.83721V21.1628C0 22.7297 1.27026 24 2.83721 24H21.1628C22.7297 24 24 22.7297 24 21.1628V2.83721C24 1.27026 22.7297 0 21.1628 0Z"
        fill={color}
      />
      <path
        d="M17.9144 4.88379C18.4307 5.73495 18.6623 6.61263 18.6623 7.721C18.6623 11.2559 15.6451 15.8466 13.1962 19.0698H7.60414L5.36182 5.65821L10.26 5.19309L11.4511 14.7359C12.5581 12.9303 13.9269 10.0931 13.9269 8.16007C13.9269 7.101 13.7455 6.381 13.4618 5.78798L17.9144 4.88379Z"
        fill="white"
      />
    </svg>
  );
};

export default Venmo;
